export const rootStyles = {
  position: "relative",
  boxSizing: "border-box",
  overflowX: "scroll",
  fontSize: "18px",
  fontFamily: 'Menlo, Consolas, "Liberation Mono", Monaco, "Lucida Console", monospace',
  minWidth: "100%",
  display: "grid"
};

export const subDivStyles = {
  position: "relative",
  gridArea: "1/1/2/2",
  display: "block"
}

export const textareaStyles = {
  lineHeight: "inherit",
  whiteSpace: "pre",
  wordBreak: "keep-all",
  background: "none",
  position: "absolute",
  width: "100%",
  height: "100%",
  zIndex: "1",
  resize: "none",
  padding: "inherit",
  paddingLeft: "2.8rem",
  outline: "none",
  fontSize: "inherit",
  fontFamily: "inherit",
  boxSizing: "border-box",
  border: "none",
  top: "0px",
  left: "0px",
  color: "inherit",
  overflow: "hidden",
  "-webkit-font-smoothing": "antialiased",
  "-webkit-text-fill-color": "transparent",
};

export const preStyles = {
  lineHeight: "inherit",
  position: "relative",
  whiteSpace: "pre-wrap",
  wordBreak: "keep-all",
  padding: "0",
  width: "100%",
  margin: "0",
  pointerEvents: "none",
  boxSizing: "border-box",
  overflowWrap: "break-word",
  fontFamily: "inherit",
};

export const linesStyles = {
  lineHeight: "inherit",
  position: "absolute",
  width: "100%",
  height: "100%",
  whiteSpace: "pre-wrap",
  wordBreak: "keep-all",
  padding: "inherit",
  margin: "0",
  top: "0px",
  left: "0px",
  pointerEvents: "none",
  boxSizing: "border-box",
  overflowWrap: "break-word",
  fontFamily: "inherit",
};